import React from 'react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Sparkles, Plus, CheckCircle, ShoppingCart } from 'lucide-react';

export const InhaberQuickStart = ({ onAddEmployee, onOpenBasisCheckout }) => (
  <Card
    className="bg-gradient-to-br from-yellow-500/10 via-gray-900/50 to-gray-900/50 border-yellow-500/40 mb-8"
    data-testid="quickstart-card"
  >
    <CardHeader>
      <CardTitle className="text-white flex items-center gap-2">
        <Sparkles className="w-5 h-5 text-yellow-500" />
        Schnellstart in 3 Schritten
      </CardTitle>
      <CardDescription>
        So bringen Sie Ihr Team in unter 5 Minuten in die SmartVolt Academy.
      </CardDescription>
    </CardHeader>
    <CardContent>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-black/40 rounded-lg p-4 border border-gray-800">
          <div className="w-8 h-8 rounded-full bg-yellow-500 text-black font-bold flex items-center justify-center mb-3">1</div>
          <p className="text-white font-medium mb-1">Mitarbeiter anlegen</p>
          <p className="text-xs text-gray-400 mb-3">Tragen Sie Name und E-Mail Ihres ersten Mitarbeiters ein.</p>
          <Button
            size="sm"
            className="bg-yellow-500 text-black hover:bg-yellow-400 w-full"
            onClick={onAddEmployee}
            data-testid="quickstart-add-employee"
          >
            <Plus className="w-4 h-4 mr-1" /> Mitarbeiter hinzufügen
          </Button>
        </div>
        <div className="bg-black/40 rounded-lg p-4 border border-gray-800">
          <div className="w-8 h-8 rounded-full bg-yellow-500 text-black font-bold flex items-center justify-center mb-3">2</div>
          <p className="text-white font-medium mb-1">Testkurs zuweisen</p>
          <p className="text-xs text-gray-400 mb-3">Weisen Sie kostenfrei den DGUV V1 Pflichtkurs zu.</p>
          <Badge className="bg-green-500/20 text-green-400 border-green-500/30 border text-[10px]">
            <CheckCircle className="w-3 h-3 mr-1" /> Gratis im Test
          </Badge>
        </div>
        <div className="bg-black/40 rounded-lg p-4 border border-gray-800">
          <div className="w-8 h-8 rounded-full bg-yellow-500 text-black font-bold flex items-center justify-center mb-3">3</div>
          <p className="text-white font-medium mb-1">Premium-Paket buchen</p>
          <p className="text-xs text-gray-400 mb-3">Schalten Sie alle Schulungen über Digistore24 frei.</p>
          <Button
            size="sm"
            variant="outline"
            className="border-yellow-500/50 text-yellow-400 hover:bg-yellow-500/10 w-full"
            onClick={onOpenBasisCheckout}
            data-testid="quickstart-buy-basis"
          >
            <ShoppingCart className="w-4 h-4 mr-1" /> Basis-Paket ansehen
          </Button>
        </div>
      </div>
    </CardContent>
  </Card>
);
